import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { User } from "firebase/auth";

interface PrivateRouteProps {
  user: User | null;
  children: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ user, children }) => {
  if (!user) {
    // Redirect to login if user is not authenticated
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
